import React from 'react';
import { PropTypes } from 'prop-types';
import { ChipButton } from './styles';
import { Text, FontWeight } from 'components/Text';
import { Icon } from 'components';

const propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func
};

const defaultProps = {
  label: null,
  onClick: value => value
};

const Chip = ({ label, onClick }) => {
  return (
    <ChipButton onClick={onClick}>
      <Text weight={FontWeight.SemiBold}>{label}</Text>
      <Icon name="close" />
    </ChipButton>
  );
};

Chip.defaultProps = defaultProps;
Chip.propTypes = propTypes;

export default Chip;
